import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import { translate } from '../../i18n/customI18nProvider';
import { getChoices, request } from '../../util';
import config from '../../config';
import { validatePositiveNumber } from '../../validators/number_validators';
import Swal from 'sweetalert2';
import {
    SimpleForm,
    Toolbar,
    SelectInput,
    NumberInput,
    useRefresh,
    AutocompleteArrayInput
} from 'react-admin';
import { convertMessageCodeToMessage } from '../../util';
import { IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from '@material-ui/core';
import { activatePackets, getPacketDetailsByShortId } from '../../services/wristbandCategory.service';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: 'whitesmoke',
    // border: '2px solid #000',
    borderRadius: '10px',
    // boxShadow: '10px 10px 5px #8d9093',
    padding: '20px',
    minWidth: '80vw',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
};

const ClientImportPacketToolbar = props => (
    <Toolbar {...props} style={{visibility: 'hidden', display: 'none'}} ></Toolbar>
);

let myChoices = [];

class ClientImportPacketClass extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            entrances: [],
            entrance_choices: [],
            selected_entrance: "",
            age_choices: [ {id: "no_age", name: translate('custom.no_age_selected')} , ...getChoices(config.entrance_ages) ],
            selected_age: "no_age",
            amount: 0,
            import_enabled: true,
            progress_percentage: 0,
            packetShortIds: [],
            packets: [],
            packetsInfo: [],
            event_id: null
        }

        this.importClients = this.importClients.bind(this);
        this.onClick = props.onClick;
    }

    async componentDidMount() {

        try {
            let entrances = await request('/entrances/all', 'GET', null);
            entrances = entrances.filter(entrance => ((entrance.type === config.entrance_types.ENTRANCE.value) || (entrance.type === config.entrance_types.UNPAID.value)));
            this.setState({entrances: entrances});
            let entrance_choices = entrances.map(entrance => ({id: entrance._id, name: entrance.name}));
            this.setState({entrance_choices: entrance_choices, event_id: entrances.length > 0 ? entrances[0].event_id : null});
        } catch(e) {
            console.log(e.message)
        }

    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.packetShortIds !== this.state.packetShortIds) {
            // Give back focus after updating packets
            const input = document.getElementById("packet-short-ids-input");
            if (input) {
                input.focus();
            }
        }
    }

    handleOpen = () => {
        this.setState({open: true});
    }

    handleClose = () => {
        this.setState({
            open: false,
            packetShortIds: [],
            packets: []
        });
        myChoices = [];
        this.onClick()
    }
    
    uncompletePacketRender = (packets) => {
        if (!packets || packets.length === 0) return '';

        // Génération des "Chips" en HTML
        const chipsHtml = packets.map(packet => `
            <span style="
                display: inline-block;
                background-color: #ed6c02;
                color: #fff;
                padding: 4px 8px;
                margin: 0 4px 5px 0;
                border-radius: 16px;
                font-family: monospace;
                font-size: 0.85rem;
                font-weight: bold;
            ">
                ${packet}
            </span>
        `).join('');

        // Accordéon natif en HTML
        return `
            <details style="text-align: left; margin-top: 10px;">
                <summary style="cursor: pointer; font-weight: bold; font-family: sans-serif; outline: none;">
                    ${translate('custom.packets_uncomplete_import')}
                </summary>
                <div style="margin-top: 10px; display: flex; gap: 10px; flex-wrap: wrap;">
                    ${chipsHtml}
                </div>
            </details>
        `;
    }

    async importClients() {
        if(this.state.amount === "" || isNaN(Number(this.state.amount))) {
            Swal.fire({
                title: translate('custom.error'),
                text: translate('custom.enter_a_valid_amount'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
            return;
        }
        if(!this.state.selected_entrance) {
            Swal.fire({
                title: translate('custom.error'),
                text: translate('custom.select_an_entrance'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
            return;
        }
        if(this.state.packets.length === 0) {
            Swal.fire({
                title: translate('custom.error'),
                text: translate('custom.no_packets_selected'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
            return;
        }
        let entrance = this.state.entrances.find(entrance => entrance._id === this.state.selected_entrance);
        if(Number(this.state.amount) < Number(entrance.price)) {
            let c = await Swal.fire({
                icon: 'warning',
                title: translate('custom.amount_is_less_than_entrance_price'),
                text: translate('custom.are_you_sure_you_want_to_continue'),
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: translate('custom.yes'),
                cancelButtonText: translate('custom.no'),
                confirmButtonColor: config.baseColor
            });
            if(!c.isConfirmed)
                return;
        }

        let selected_age = this.state.selected_age;
        if(this.state.selected_age === "no_age") selected_age = null;

        const inProgressSwal = Swal.fire({
            title: translate('custom.processing'),
            text: '0 %',
            allowOutsideClick: false,
            showCancelButton: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        
        try {
            let response = await activatePackets(this.state.packets, this.state.selected_entrance, this.state.amount, selected_age);

            if(response.error) {
                inProgressSwal.close();
                Swal.fire({
                    title: translate('custom.error'),
                    text: response.error_code ? (convertMessageCodeToMessage(response.error_code)) : (response.error ? response.error : translate('custom.unknown_error')),
                    icon: 'error',
                    confirmButtonText: translate('custom.ok'),
                    confirmButtonColor: config.baseColor
                });
            } else {
                let success = response.activated_count;
                let skipped = response.warnings?.length || 0;
                let failure = response.errors?.length || 0;
                const uncompletePackets = [];
                for(const log of response.packet_logs) {
                    if(log.activated < log.total) {
                        uncompletePackets.push(log.shortId);
                    }
                }
                let import_id = response.import_id;
                await Swal.fire({
                    title: translate('custom.import_completed'),
                    html: translate('custom.success') + ": " + success + "<br>"  +
                            translate('custom.failure') + ": " + failure + "<br>" +
                            translate('custom.skipped') + ": " + skipped + "<br>" +
                            translate('custom.import_id') + ": " + import_id + 
                            (uncompletePackets.length > 0 ? this.uncompletePacketRender(uncompletePackets) : ''),
                    icon: 'success',
                    confirmButtonText: translate('custom.ok'),
                    confirmButtonColor: config.baseColor
                });
                if(success > 0) {
                    this.props.refresh();
                    this.handleClose();
                }
            }
        } catch(e) {
            inProgressSwal.close();
            Swal.fire({
                title: translate('custom.error'),
                text: e.message ? e.message : translate('custom.unknown_error'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
        }
    }

    findPacketsByShortId(shortId) {
        return this.state.packets.find(packet => packet.shortId === shortId);
    }

    async refreshPackets(packetShortIds) {
        for(const shortId of packetShortIds) {
            const packet = this.findPacketsByShortId(shortId);
            if(!packet) {
                // Fetch packet details
                let packetInfo = {
                    shortId: shortId,
                    error: translate('custom.packet_not_found'),
                }
                try {
                    const response = await getPacketDetailsByShortId(shortId);
                    if(response._id) {
                        packetInfo = {
                            shortId: shortId,
                            from: response.minNumber || null,
                            to: response.maxNumber || null,
                            pcs: response.quantity - (response.rangeWarning ? response.rangeWarning.length : 0),
                            rangeWarning: response.rangeWarning
                        }
                    }
                } catch (error) {
                    console.log("Error fetching packet details: ", error.message);
                }
                this.setState({packets: [...this.state.packets, packetInfo]});
                this.setState({packetsInfo: [...this.state.packetsInfo, {...packetInfo}]});
            }
        }
        this.setState({packets: this.state.packets.filter(packet => packetShortIds.includes(packet.shortId))});
        myChoices = packetShortIds.map(id => ({id: id, name: id}));
    }

    handleChangePackets = async (value) => {
        this.setState({packetShortIds: value});
        this.refreshPackets(value);
    }

    packetForm(packet) {
        const handleChangeForm = (event, packet) => {
            const { name, value } = event.target;
            const updatedPackets = [...this.state.packets];

            if (packet) {
                packet[name] = value;
                // Recalculate pcs if from or to changed
                if (name === 'from' || name === 'to') {
                    const packetInfo = this.state.packetsInfo.find(p => p.shortId === packet.shortId);
                    const minNumber = packetInfo ? Number(packetInfo.from) : 0;
                    const maxNumber = packetInfo ? Number(packetInfo.to) : 0;
                    const from = Number(packet.from);
                    const to = Number(packet.to);
                    if (from < minNumber || from > maxNumber || to < minNumber || to > maxNumber) {
                        packet.formError = translate('custom.range_must_be_within_packet_limits') + ` [${minNumber} - ${maxNumber}]`;
                        packet.pcs = '-';
                    } else {
                        packet.formError = null;
                        if (!isNaN(from) && !isNaN(to) && to >= from) {
                            packet.pcs = to - from + 1;
                        } else {
                            packet.pcs = 0;
                        }
                    }
                }
                updatedPackets.splice(updatedPackets.findIndex(p => p.shortId === packet.shortId), 1, packet);
            }

            this.setState({ packets: updatedPackets });
        };

        const generateWarningTitle = (warnings) => {
            let alreadyExistsOnThisEvent = 0;
            let alreadyExsitsOnOtherEvent = 0;
            let otherEvents = [];
            for(const warning of warnings) {
                if(warning.event.id === this.state.event_id) {
                    alreadyExistsOnThisEvent += 1;
                } else {
                    alreadyExsitsOnOtherEvent += 1;
                    if(!otherEvents.includes(warning.event.name)){
                        otherEvents.push(warning.event.name);
                    }
                }
            }
            let title = '';
            if(alreadyExistsOnThisEvent > 0) {
                title += alreadyExistsOnThisEvent + " " + translate('custom.wristband_already_used_on_this_event') + '\n';
            }
            if(alreadyExsitsOnOtherEvent > 0) {
                let eventText = ' (' + otherEvents.join(', ') + ')';
                title += alreadyExsitsOnOtherEvent + " " + translate('custom.wristband_already_used_on_other_event') + eventText + '\n';
            }
            return title.trim();
        };

        return (
            <TableRow
              key={packet.shortId}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell>{(packet.error || packet.formError) ? 
                        <div title={packet.formError}><ErrorIcon color="error" /></div> 
                    : packet.rangeWarning?.length > 0 ?
                        <div title={generateWarningTitle(packet.rangeWarning)}><WarningIcon color="warning" /></div> 
                    :
                    <CheckCircleIcon color="success" />}</TableCell>
                <TableCell component="th" scope="row">{packet.shortId}</TableCell>
                {
                    packet.error ? (
                        <TableCell colSpan={3} style={{color: 'red'}}>{packet.error}</TableCell>
                    ) : (
                        <>
                            <TableCell style={{padding: '0px'}}>
                                <TextField 
                                    value={packet.from}
                                    name="from"
                                    onChange={(event) => handleChangeForm(event, packet)} 
                                    variant="outlined"
                                    size="small"
                                    disabled
                                />
                            </TableCell>
                            <TableCell style={{padding: '0px'}}>
                                <TextField 
                                    value={packet.to} 
                                    name="to"
                                    onChange={(event) => handleChangeForm(event, packet)} 
                                    variant="outlined"
                                    size="small"
                                    disabled
                                />
                            </TableCell>
                            <TableCell align="right">{packet.pcs}</TableCell>
                        </>
                    )
                }
                <TableCell style={{ width: '1px', whiteSpace: 'nowrap' }}>
                    <IconButton
                        color="secondary"
                        onClick={() => {
                            const newPacketShortIds = this.state.packetShortIds.filter(id => id !== packet.shortId);

                            this.setState({
                                packetShortIds: newPacketShortIds,
                                packets: this.state.packets.filter(p => p.shortId !== packet.shortId)
                            });
                            myChoices = newPacketShortIds.map(id => ({id: id, name: id}));
                        }}
                        variant="contained"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        )
    }

    render() {
        return (
            <div>                
                <MenuItem onClick={this.handleOpen}>
                    {translate('custom.import_packets')}
                </MenuItem>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    // className={classes.modal}
                    style={styles.modal}
                    open={this.state.open}
                    onClose={this.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.open}>
                        {/* <div className={classes.paper}> */}
                        <div style={styles.paper}>


                            <SimpleForm toolbar={<ClientImportPacketToolbar />} >

                                <SelectInput
                                    source="entrance"
                                    label={translate('custom.entrance')}
                                    choices={this.state.entrance_choices}
                                    value={this.state.selected_entrance}
                                    onChange={e => this.setState({selected_entrance: e.target.value})}
                                    fullWidth={true}
                                    variant="outlined"
                                />

                                <NumberInput
                                    source="amount"
                                    label={translate('custom.amount')}
                                    value={this.state.amount}
                                    step={1}
                                    validate={validatePositiveNumber}
                                    onChange={e => this.setState({amount: e.target.value})}
                                    fullWidth={true}
                                    variant='outlined'
                                    onWheel={(e) => e.target.blur()}
                                />

                                <SelectInput
                                    source="age"
                                    label={translate('custom.age')}
                                    choices={this.state.age_choices}
                                    value={this.state.selected_age}
                                    onChange={e => this.setState({selected_age: e.target.value})}
                                    fullWidth={true}
                                    variant="outlined"
                                />

                                <AutocompleteArrayInput fullWidth label={translate('custom.packets')} source="packetShortIds" choices={myChoices} variant='outlined'
                                    defaultHighlightedIndex={0}
                                    key={JSON.stringify(this.state.packetShortIds)}
                                    id="packet-short-ids-input"
                                    format={() => this.state.packetShortIds}
                                    parse={value => {
                                        this.handleChangePackets(value);
                                        return value;
                                    }}
                                    onCreate={(text) => {
                                        text = text.toUpperCase().trim();
                                        if(text === "") {
                                            text = prompt(translate('custom.enter_a_new_one_to_create'));
                                            if(text === null) {
                                                return null;
                                            }

                                            if (text.includes('\n')) {
                                                text = text.split('\n');
                                                let newTags = [];
                                                for (let i=0; i<text.length; i++) {
                                                    text[i] = text[i].trim();
                                                    if (text[i] === "")
                                                        continue;
                                                    const newTag = { id: String(text[i]), name: text[i] };
                                                    if (myChoices.find((choice) => choice.id === newTag.id)) {
                                                        newTags.push(myChoices.find((choice) => choice.id === newTag.id));
                                                    } else {
                                                        myChoices.push(newTag);
                                                        newTags.push(newTag);
                                                    }
                                                }
                                                return newTags[0];
                                            } else {
                                                const newTag = { id: String(text), name: text };
                                                if (myChoices.find((choice) => choice.id === newTag.id)) {
                                                    return myChoices.find((choice) => choice.id === newTag.id);
                                                } else {
                                                    myChoices.push(newTag);
                                                    return newTag;
                                                }
                                            }
                                        } else {
                                            const newTag = { id: String(text), name: text };
                                            if (myChoices.find((choice) => choice.id === newTag.id)) {
                                                return myChoices.find((choice) => choice.id === newTag.id);
                                            } else {
                                                myChoices.push(newTag);
                                                return newTag;
                                            }
                                        }
                                    }}
                                />

                                <TableContainer component={Paper} style={{width: '100%', marginTop: '20px', marginBottom: '20px', maxHeight: '500px'}}>
                                    <Table aria-label="simple table" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell>{translate('custom.short_id')}</TableCell>
                                                <TableCell>{translate('custom.from')}</TableCell>
                                                <TableCell>{translate('custom.to')}</TableCell>
                                                <TableCell align='right'>{translate('custom.pcs')}</TableCell>
                                                <TableCell align='right' sx={{ width: '1%', whiteSpace: 'nowrap' }}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            { 
                                                this.state?.packets && this.state.packets.length > 0 ? this.state.packets.map((packet) => this.packetForm(packet)) : 
                                                <TableRow>
                                                    <TableCell colSpan={6} align='center'>
                                                        {translate('custom.no_packets_selected')}
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow style={{ position: "sticky", bottom: 0, backgroundColor: "whitesmoke"}}>
                                                <TableCell style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {translate('custom.total')}
                                                </TableCell>
                                                <TableCell style={{fontWeight: 'bold', fontSize: '14px'}} colSpan={3}>
                                                    { this.state.packets.length }
                                                </TableCell>
                                                <TableCell style={{fontWeight: 'bold', fontSize: '14px'}} align='right'>
                                                    { this.state.packets.reduce((sum, packet) => sum + (packet.pcs && !isNaN(Number(packet.pcs)) ? Number(packet.pcs) : 0), 0) }
                                                </TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>

                                <Button
                                    color="primary"
                                    onClick={this.importClients}
                                    variant="contained"
                                    size="small"
                                    fullWidth={true}
                                    disabled={!this.state.import_enabled}
                                >
                                    {translate('custom.import')}
                                </Button>

                            </SimpleForm>

                        </div>
                    </Fade>
                </Modal>
            </div>
        );
    }

}

const ClientImportPacket = (props) => {
    
    const refresh = useRefresh();
    return <ClientImportPacketClass {...props} refresh={refresh} />
}
export default ClientImportPacket;